// extracted by mini-css-extract-plugin
export default {"configureModal":"ConfigureFolder_configureModal__NLHZ+","configureTitle":"ConfigureFolder_configureTitle__CL9N5"};